import { request, language } from 'base-libs';

function getCoupon(actid) {
    let p = request.get(`/cgi-bin/ia_wcerp_prom_exec_act.cgi?act_listid=${actid}`);
    p = p.then((data) => {
        return data;
    });
    return p;
}

function getLangConfig() {
    let lang = language.getLang(['zh_hk', 'en', 'id'], 'en');
    lang = lang.replace(/_/g, '-');
    console.log('###', lang);
    let p = request.loadVtools(`//hb.moneydata.hk/vtools/i18n/action/smartone/${lang}/smartone_1810_utf8.js`, 5 * 60 * 1000);
    p = p.then(data => ({
        lang: lang,
        langObj: data
    }));
    return p;
}

export { getCoupon, getLangConfig };
